<template>
    <div class="parent row mb-4 d-flex justify-content-center align-items-center" >
        <div class="col-4">
  <img :src="this.image" class="img_sizing card-img-top" alt="...">

        </div>
  <div class="col-5">
    <h5 class="no_overflow card-title">{{ this.title }}</h5>
  </div>
  <div class="col-3">
    <p class="no_overflow card-text">${{ this.price }}</p>
  </div>
</div>
</template>

<script>
export default{
    name:"ProductRow",
    props: {
    title: String,
    description: String,
    image: String,
    price: Number
  },
  methods:{
    displayModal(){
      console.log("hello")
    }
  }
}
</script>

<style scoped>
.parent{
    border-bottom: 3px solid orange;
    mask-border:inherit;
    overflow: hidden;
}
.no_overflow{
    white-space: nowrap;         /* Prevents line breaks */
  overflow: hidden;            /* Hides overflow text */
  text-overflow: ellipsis; 
}
.img_sizing{
    height: 120px;
    width: 90px;
    border-radius: 12px;
}
</style>